"use client";

import { useState } from "react";
import { Box, MenuItem, Stack, TextField } from "@mui/material";
import { RANGE_PRESETS } from "@lib/settings/dateRanges";

export default function DateRangePicker({ value, onChange }) {
  const preset = value?.preset ?? "7d";
  const [customFrom, setCustomFrom] = useState(value?.from ?? "");
  const [customTo, setCustomTo] = useState(value?.to ?? "");

  const handlePresetChange = (event) => {
    const next = event.target.value;
    if (next === "custom") {
      onChange({
        preset: "custom",
        from: customFrom || null,
        to: customTo || null,
      });
    } else {
      onChange({ preset: next, from: null, to: null });
    }
  };

  const handleCustomChange = (field, val) => {
    if (field === "from") setCustomFrom(val);
    if (field === "to") setCustomTo(val);
    const nextFrom = field === "from" ? val : customFrom;
    const nextTo = field === "to" ? val : customTo;
    if (nextFrom && nextTo) {
      onChange({ preset: "custom", from: nextFrom, to: nextTo });
    }
  };

  return (
    <Stack spacing={1} sx={{ mb: 1 }}>
      <TextField
        select
        size="small"
        label="Date range"
        value={preset}
        onChange={handlePresetChange}
        sx={{ maxWidth: 240 }}
      >
        {RANGE_PRESETS.map((p) => (
          <MenuItem key={p.key} value={p.key}>
            {p.label}
          </MenuItem>
        ))}
      </TextField>
      {preset === "custom" && (
        <Box sx={{ display: "flex", gap: 1 }}>
          <TextField
            type="date"
            size="small"
            label="From"
            slotProps={{ inputLabel: { shrink: true } }}
            value={customFrom}
            onChange={(e) => handleCustomChange("from", e.target.value)}
          />
          <TextField
            type="date"
            size="small"
            label="To"
            slotProps={{ inputLabel: { shrink: true } }}
            value={customTo}
            onChange={(e) => handleCustomChange("to", e.target.value)}
          />
        </Box>
      )}
    </Stack>
  );
}
